import { useEffect, useState, type ReactElement, type ReactNode } from 'react';
import { AuthCallbackPage } from './AuthCallbackPage';

function usePathname(): string {
  const [pathname, setPathname] = useState(() => window.location.pathname);
  useEffect(() => {
    const onPop = (): void => setPathname(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  return pathname;
}

/** Minimal pathname gate for OAuth callback without adding react-router. */
export function AuthRouteGate({ children }: { children: ReactNode }): ReactElement {
  const pathname = usePathname();
  if (pathname === '/auth/callback' || pathname.startsWith('/auth/callback/')) {
    return <AuthCallbackPage />;
  }
  return <>{children}</>;
}
